import './index.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import DittoProvider from 'ditto-react';
import { ConfigProvider } from 'antd';
import { Provider } from 'mobx-react';
import { ThemeProvider } from 'styled-components';
import { datadogRum } from '@datadog/browser-rum';

import theme from '@css/theme';
import light from '@ui-library/tokens/light.json';
import { stores } from '@stores/index';
import { ErrorBoundary } from '@lib/bugsnag';
import { ErrorPage } from '@components/common/errorPage';
import { IS_ADMIN_WEB_APP, DATADOG_APP_ID, DATADOG_CLIENT_TOKEN } from '@config';

import AppRouter from './auth/appRouter';
import GlobalStyles from './globalStyles';
import { lazyLoadedScripts, loadSessionFromUrl } from './scripts';
import dittoData from './ditto';

if (IS_ADMIN_WEB_APP) {
  loadSessionFromUrl();
}

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <DittoProvider source={dittoData}>
      <ConfigProvider
        theme={{
          token: {
            ...light,
            fontFamily: `'Inter', 'Roboto', 'Noto Sans', 'Open Sans', 'Lato', 'Source Sans Pro', sans-serif`,
          },
          components: {
            Button: {
              borderRadius: light.borderRadiusXXL,
              borderRadiusLG: light.borderRadius3XL,
              borderRadiusSM: light.borderRadiusXXL,
              fontSizeLG: light.fontSize,
            },
            Table: {
              borderRadius: 0,
              borderRadiusLG: 0,
            },
            Segmented: {
              colorBgLayout: light.colorFillTertiary,
            },
            Modal: {
              borderRadiusLG: light.borderRadiusXL,
            },
          },
        }}
      >
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <Provider {...stores}>
            <div className="App" data-version={process.env.REACT_APP_VERSION}>
              <AppRouter />
            </div>
          </Provider>
        </ErrorBoundary>
      </ConfigProvider>
    </DittoProvider>
  </ThemeProvider>,
  document.getElementById('root'),
);

datadogRum.init({
  applicationId: DATADOG_APP_ID,
  clientToken: DATADOG_CLIENT_TOKEN,
  site: 'datadoghq.com',
  service: 'control-plane-webapp',
  env: process.env.REACT_APP_ENV,
  version: process.env.REACT_APP_VERSION,
  sampleRate: 100,
  replaySampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
});

lazyLoadedScripts();
